import { render, staticRenderFns } from "./CISynchronizerSupport.vue?vue&type=template&id=cc97572a&"
import script from "./CISynchronizerSupport.vue?vue&type=script&lang=js&"
export * from "./CISynchronizerSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports